import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_skeleton_media = _resolveComponent("skeleton-media")
  const _component_skeleton_paragraph = _resolveComponent("skeleton-paragraph")
  const _component_skeleton_button = _resolveComponent("skeleton-button")
  const _component_skeleton_wrapper = _resolveComponent("skeleton-wrapper")

  return (_openBlock(), _createBlock(_component_skeleton_wrapper, { class: "_flexcol _gap-3" }, {
    default: _withCtx(() => [
      _createVNode(_component_skeleton_media, { "media-lines": 3 }),
      _createVNode(_component_skeleton_paragraph, { lines: 5 }),
      _createVNode(_component_skeleton_button)
    ]),
    _: 1 /* STABLE */
  }))
}